import NroseLogo from 'src/modules/products/assets/nrose.svg';
import NboostLogo from 'src/modules/products/assets/nboost.svg';
import NliftLogo from 'src/modules/products/assets/nlift.svg';
import styled, { css } from 'styled-components';
import { FC } from 'react';
import { media } from 'src/styles/designs';

export interface ProductLogoProps {
  name?: string;
  code: string;
  size?: 'default' | 'big';
}

const codeLogoMap: Record<string, string> = {
  nrose: NroseLogo,
  nboost: NboostLogo,
  nlift: NliftLogo,
};

const Heading = styled.h2<{ $size: ProductLogoProps['size'] }>`
  font-size: 42px;
  color: ${({ theme }) => theme.text.palette.primary};

  width: auto;
  height: 36px;

  svg {
    width: auto;
    height: 100%;
  }

  ${({ $size }) =>
    $size === 'big' &&
    css`
      width: 160px;
      height: 60px;

      ${media.w.greaterThanOrEqual.desktop} {
        width: 210px;
        height: 83px;
      }
    `}
`;

export const ProductLogo: FC<ProductLogoProps> = ({
  name,
  code,
  size = 'default',
}) => {
  const Logo = codeLogoMap[code];

  return <Heading $size={size}>{Logo ? <Logo /> : name ?? code}</Heading>;
};
